import React, { useContext, useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { Checkbox, FormGroup, FormControl, FormControlLabel, TextField, Radio, Typography } from "@mui/material";
import { useSnackbar } from "notistack";
import ButtonTheme from "../../ThemeButton/ThemeButton";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { useDispatch, useSelector } from "react-redux";
import ApiService from "../../../functions/apiService";
import { setDashboardAbsentReason } from "../../../store/dashboardReducer";
import Error from "../../Error/Error";
import ConfModal from "../../Modal/ConfModal";
import MyTable from "../../Schedule/MyTable";
import { getGridStringOperators } from "@mui/x-data-grid";
import { toast } from 'react-toastify';

export default function ResetPasswords() {
    // const { enqueueSnackbar } = useSnackbar();
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);
    const [modalData, setModalData] = useState([]);
    const {
        register,
        control,
        formState: { errors, isValid },
        handleSubmit,
        setError,
        setValue,
        getValues,
        reset,
        watch
    } = useForm({
        defaultValues: {},
    });
    let columns = [
        {
            field: 'Emp_Code', headerName: 'ID', flex: 1, minWidth: 120,
            filterOperators: getGridStringOperators().filter(
                (operator) => operator.value === "contains"
            ),
        },
        {
            field: 'fullName', headerName: 'Name', flex: 1, minWidth: 120,
            valueGetter: (params) => params.row.EA_Rank + ' ' + params.row.fullName,
            filterOperators: getGridStringOperators().filter(
                (operator) => operator.value === "contains"
            ),

        },



    ];
    const onSubmit = (body) => {
        ApiService.post('/employeeResetPasswords', body).then((data) => {
            setLoading(false);
            console.log('data', data);
            setModalData(data)
            setOpen(true);
            toast.success('Password reset successfully')
            // enqueueSnackbar('success', { variant: 'success' });
        }).catch(({ data }) => {
            setLoading(false);
            toast.error('Error')
            // enqueueSnackbar('Error', { variant: 'error' });
        });
        console.log('body', body);
    }
    let closeModal = () => {
        setOpen(false);
    }
    return <>
        <Typography fontWeight='700' fontSize="16px"> Passwords</Typography>
        <form onSubmit={handleSubmit(onSubmit)} className="row">
            <div className="col-12">
                <FormGroup row>
                    <FormControlLabel control={<Checkbox value='Officers' {...register("Option", { required: "Option  is required." })} />} label={<Typography sx={{ fontSize: '14px' }}>Officers</Typography>} />
                    <FormControlLabel control={<Checkbox value='FFs' {...register("Option", { required: "Option  is required." })} />} label={<Typography sx={{ fontSize: '14px' }}>FFs</Typography>} />
                    <FormControlLabel control={<Checkbox value='Dispatch/FAOs' {...register("Option", { required: "Option  is required." })} />} label={<Typography sx={{ fontSize: '14px' }}>Dispatch/FAOs</Typography>} />
                    <FormControlLabel control={<Checkbox value='Admin' {...register("Option", { required: "Option  is required." })} />} label={<Typography sx={{ fontSize: '14px' }}>Admin</Typography>} />
                </FormGroup>
                {errors.Value && (<Error >{errors.Value?.message}</Error>)}
            </div>
            <div className="col-12 mt-3">
                <ButtonTheme disabled={!isValid} color='primary' type='submit'>Update Passwords</ButtonTheme>
            </div>


        </form>
        <ConfModal Title='Employees' open={open} closeModal={closeModal} >
            {modalData && modalData.message &&
                <p class="h4 my-2">{modalData.message}</p>
            }
            {modalData && modalData.data && modalData.data.length > 0 &&

                <div >
                    <MyTable
                        rows={modalData.data}
                        columns={columns}
                        useTopFilter={false}
                        checkboxSelection={false}
                        hideFooter={true}
                    />
                </div>

            }
        </ConfModal>
    </>
}
